;(function () {
  angular
    .module('contrast.vulnerabilities')
    .controller('TraceRequestModalInstanceCtrl', TraceRequestModalInstanceCtrl)

  function TraceRequestModalInstanceCtrl(
    $scope,
    $uibModalInstance,
    traceCommonRenderService,
    httpRequest
  ) {
    'ngInject'

    var _request

    angular.extend($scope, {
      replay: replay,
      cancel: cancel,
      remove: remove,
      addParameter: addParameter
    })

    function init() {
      _request = httpRequest.data.http_request
      _initDefaults()
    }

    function _initDefaults() {
      angular.extend($scope, {
        model: {
          select: ['GET', 'POST'],
          method: _request.method,
          url: _request.url,
          parameters: _request.parameters ? _request.parameters : [],
          body: _request.body,
          headers: _request.headers
        }
      })
    }

    function replay() {
      traceCommonRenderService.replay($scope)
    }

    function cancel() {
      $uibModalInstance.dismiss('cancel')
    }

    function remove(index) {
      $scope.model.parameters.splice(index, 1)
    }

    function addParameter() {
      $scope.model.parameters.push({ name: '', value: '' })
    }

    init()
  }
})()
